import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from 'parse';
import Api from '../../Utils/api';
import _ from 'lodash';
import ReactDragListView from 'react-drag-listview';
import Utility from '../../Utils/Utility'

export default class AddOptions extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            options: [],
            errors:{}
        };
        this._bind(
            'loadOptions'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {
        // when load the main class get all the data and reload

        this.setState({
            options: this.loadOptions(this.props.itemOptions)
        });
    }


    // componentWillMount() {
    //     this.setState({
    //         options: this.loadOptions(this.props.itemOptions)
    //     });
    // }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== null) {
            this.setState({
                    options: this.loadOptions(nextProps.itemOptions)
                });
        }
    }

    loadOptions(itemOptions){

        let opts = [];
        // let itemOptions = this.props.itemOptions;

        if (itemOptions && itemOptions.length > 0) {
            itemOptions.map((itemOp, i) => {

                let optionName = Object.keys(itemOp)[0];
                let nestedJson = itemOp[optionName];

                let optDesc = {};

                optDesc['name'] = optionName;
                optDesc["price"] = nestedJson.price;
                optDesc["oos"] = nestedJson.oos == 1 ? true : false;
                optDesc["omItemOptionId"] = nestedJson.omItemOptionId ? nestedJson.omItemOptionId : "";

                opts.push(optDesc)

            });
        }

        return opts
    }

    addClick(){
//// itemOptionName key can't have . & - in it for ex. Dr. Pepper and Dr - Pepper
        let self = this;

        this.setState(prevState => ({
            options: [...prevState.options, { name: "", price: "0", oos: false}]
        }),()=>{
            self.props.callBackAddOptions(self.convertIntoOptions(self.state.options));
        })
    }

    convertIntoOptions(itemOptions){
        let opts = [];
        // let itemOptions = item.itemOptions;

        itemOptions.map((itemOp, i) => {

            let optName = {};
            let optDesc = {};

                let decimalCountNo = Utility.decimalCount(itemOp.price);
                if (decimalCountNo > 2){
                    optDesc["price"] = Utility.toRoundStr(itemOp.price, 2);
                }
                else {
                    optDesc["price"] = itemOp.price;
                }

            optDesc["oos"] = itemOp.oos == 1 ? true : false;
            optDesc["omItemOptionId"] = itemOp.omItemOptionId ? itemOp.omItemOptionId : "";
            optName[itemOp.name] = optDesc;

            opts.push(optName)

        });

        return opts

    }


    createUI(){
        return this.state.options.map((el, i) => (
            <li key={i}>
                    <div className="row form-group-options">
                        <div className="col-xs-1">
                            <a type="button" href="JavaScript:void(0);" className="btn-rearrange"><i className="fa fa-bars" aria-hidden="true"></i></a>
                        </div>
                        <div className="col-xs-4">
                            <input type="text" className="form-control" placeholder="Name" name="name" value={el.name}
                                   onChange={this.handleChange.bind(this, i)}/>
                        </div>
                        <div className="col-xs-3">
                            <input type="tel" pattern="^-?[0-9]\d*\.?\d*$" className="form-control" placeholder="Price" name="price" value={el.price}
                                   onChange={this.handleChange.bind(this, i)}/>
                           <small className="form-text text-muted">Price should be a numerical value</small>                        </div>
                        <div className="col-xs-2">
                            <label className="radio-inline">
                                <input type="checkbox" name="oos" id="oos" checked={el.oos || false} onClick={this.handleChange.bind(this, i)} /> Out Of Stock
                            </label>
                        </div>
                        <div className="col-xs-1">
                            {/*<input className="form-control" type='button' value='X'*/}
                                   {/*onClick={this.removeClick.bind(this, i)}/>*/}
                            <button type="button" className="btn btn-danger btn-md" onClick={this.removeClick.bind(this, i)}><i className="fa fa-remove" aria-hidden="true"></i></button>
                        </div>

                    </div>
            </li>
        ))
    }

    handleChange(i, e) {

        let self = this;
        var { name, value } = e.target;

        if (name == "name"){
            value = value.replace(/[^\w\s]/gi, " ");
        }

        let oosName = false;
        let oos = false;
        if (name == "oos"){
            oosName = true;
            oos = e.target.checked;
        }

        if (name == 'price') {

            let validNumber = new RegExp(/^\d*\.?\d*$/);
            if (!validNumber.test(value)) {
                let error = "Price format is wrong. It must be a numerical value like $2.00";
                // alert(error);
                let errors = {};
                errors["errors"] = error;
                this.setState({errors: errors});
                return
            }
        }

        let options = [...this.state.options];
        options[i] = {...options[i], [name]: oosName == true ? oos : value};
        this.setState({ options },()=>{
            self.props.callBackAddOptions(self.convertIntoOptions(self.state.options));
        });


    }

    removeClick(i){

        let self = this;
        let options = [...this.state.options];
        options.splice(i, 1);
        this.setState({ options },()=>{
            self.props.callBackAddOptions(self.convertIntoOptions(self.state.options));
        });

    }

    // handleSubmit(event) {
    //     alert('A name was submitted: ' + JSON.stringify(this.state.options));
    //     event.preventDefault();
    // }

    render() {
        const self = this;
        const dragProps = {
            onDragEnd(fromIndex, toIndex) {
                const options = [...self.state.options];
                const item = options.splice(fromIndex, 1)[0];
                options.splice(toIndex, 0, item);
                self.setState({ options },()=>{
                    self.props.callBackAddOptions(self.convertIntoOptions(self.state.options));
                });
            },
            nodeSelector: 'li',
            handleSelector: 'a'
        };
        return (
            <div>
                {/*onSubmit={this.handleSubmit}*/}
                <div className="row">
                    {
                        this.state.errors && this.state.errors["errors"] ? (
                            <div className="alert alert-danger text-center" role="alert">
                                <span className="form-text">{this.state.errors["errors"]}</span>
                            </div>) : null

                    }
                <button type="button" className="btn btn-success btn-sm float-right" onClick={this.addClick.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> Add Options
                </button>
                </div>
                <div className="row col-lg-12">
                <ReactDragListView {...dragProps}>
                    <ul className="add-options-ul">
                {this.createUI()}
                    </ul>
                </ReactDragListView>
                </div>
                {/*<input type="submit" value="Submit" />*/}
            </div>
        );
    }

}





// WEBPACK FOOTER //
// src/components/online-menu/add-options.js